export default "__VITE_ASSET__CfyWopqs__"